<div class="flex flex-row justify-between mb-4">
  <p-breadcrumb
    [model]="[]"
    [home]="home"
  />
  <div class="flex align-items-center gap-2">
    <label for="showAcknowledged">Bestätigte anzeigen</label>
    <p-toggleSwitch
      [(ngModel)]="showAcknowledged"
      inputId="showAcknowledged"
    ></p-toggleSwitch>
  </div>
</div>

<p-table
  [columns]="cols"
  [value]="filteredItems"
  [scrollable]="true"
  [virtualScroll]="true"
  [virtualScrollItemSize]="46"
  showGridlines
  scrollHeight="calc(100svh - 50px - 1.5rem)"
  [tableStyle]="{ 'min-width': '50rem' }"
  [globalFilterFields]="['versionsUnique', 'userId', 'created', 'startDate', 'endDate']"
>
  <ng-template
    #header
    let-columns
  >
    <tr>
      @for (col of columns; track col.field) {
      <th style="min-width: 150px;">{{ col.header }}</th>
      }
      <th style="min-width: 120px;">Aktionen</th>
    </tr>
  </ng-template>

  <ng-template
    #body
    let-rowData
  >
    <tr style="height:46px">
      <td>{{ rowData?.created | date: 'dd.MM.yyyy HH:mm' }}</td>
      <td>{{ rowData?.fallaufgabenName }}</td>
      <td><code>{{ rowData?.userId }}</code></td>
      <td>
        <p-tag
          [value]="getWarningCount(rowData) + ''"
          severity="warn"
          [pTooltip]="getWarningTypeSummary(rowData)"
          tooltipPosition="top"
        ></p-tag>
      </td>
      <td>{{ rowData?.startDate | date: 'dd.MM.yyyy HH:mm' }}</td>
      <td>{{ rowData?.endDate | date: 'dd.MM.yyyy HH:mm' }}</td>
      <td>
        <p-button
          icon="pi pi-eye"
          [rounded]="true"
          [text]="true"
          severity="info"
          [disabled]="!rowData"
          (onClick)="openDetails(rowData)"
          pTooltip="Details ansehen"
        ></p-button>
        @if (rowData && !rowData.acknowledged) {
        <p-button
          icon="pi pi-check"
          [rounded]="true"
          [text]="true"
          severity="success"
          (onClick)="acknowledge(rowData)"
          pTooltip="Bestätigen"
        ></p-button>
        }
        @if (rowData?.acknowledged) {
        <p-button
          icon="pi pi-undo"
          [rounded]="true"
          [text]="true"
          severity="warn"
          (onClick)="unacknowledge(rowData)"
          pTooltip="Bestätigung aufheben"
        ></p-button>
        }
      </td>
    </tr>
  </ng-template>

  <ng-template #emptymessage>
    <tr>
      <td
        colspan="7"
        class="text-center py-4"
      >Keine Betrugswarnungen gefunden.</td>
    </tr>
  </ng-template>
</p-table>

<p-dialog
  [(visible)]="showDetailsDialog"
  [header]="'Warnungsdetails: ' + (selectedWarning?.userId ?? '')"
  [modal]="true"
  [maximizable]="true"
  [style]="{ width: '80vw' }"
>
  @if (selectedWarning) {
  <div class="mb-4">
    <p><strong>Status ID:</strong> <code>{{ selectedWarning.statusId }}</code></p>
    <p><strong>Fallaufgabe:</strong> <strong>{{ selectedWarning.fallaufgabenName }}</strong></p>
    <p><strong>Version:</strong> <strong>{{ selectedWarning.versionsUnique }}</strong></p>
    <p><strong>Nutzer:</strong> <code>{{ selectedWarning.userId }}</code></p>
    <p><strong>Start:</strong> {{ selectedWarning.startDate | date: 'dd.MM.yyyy HH:mm' }}</p>
    <p><strong>Ende:</strong> {{ selectedWarning.endDate | date: 'dd.MM.yyyy HH:mm' }}</p>
  </div>

  <div class="mb-4">
    <h3>Warnungen ({{ selectedWarning.fraudWarnings.length }})</h3>
    @for (warning of selectedWarning.fraudWarnings; track warning.type + warning.created) {
    <div class="border rounded p-3 mb-3">
      <p><strong>Typ:</strong>
        <p-tag
          [value]="getWarningLabel(warning.type)"
          [severity]="getWarningSeverity(warning.type)"
        ></p-tag>
      </p>
      @if (warning.ip) {
      <p><strong>IP-Adresse:</strong> <code>{{ warning.ip }}</code></p>
      }
      @if (warning.fraudProbability != null) {
      <p><strong>Wahrscheinlichkeit:</strong>
        <p-tag
          [value]="(warning.fraudProbability * 100 | number:'1.0-0') + '%'"
          [severity]="getWarningSeverity(warning.type)"
        ></p-tag>
      </p>
      }
      <p><strong>Erkannt:</strong> {{ warning.created | date: 'dd.MM.yyyy HH:mm:ss' }}</p>
      <p><strong>Zuletzt aktualisiert:</strong> {{ warning.updated | date: 'dd.MM.yyyy HH:mm:ss' }}</p>

      @if (warning.copyStats) {
      <div class="mt-3">
        <strong>Kopierquote:</strong>
        <p-tag
          class="ml-2"
          [value]="(getCopyRatioPercent(warning) ?? 0) + '%'"
          [severity]="getWarningSeverity(warning.type)"
        ></p-tag>
        <p class="mt-2 mb-1">
          {{ warning.copyStats.copiedTeilaufgabenCount }} von {{ warning.copyStats.totalTeilaufgabenCount }} Fragetexten
          wurden kopiert.
        </p>
        <p class="mb-2 text-sm text-slate-600">
          Schwellenwert: {{ warning.copyStats.threshold * 100 | number:'1.0-0' }}%
        </p>
        @if (warning.copyStats.copiedTeilaufgaben.length > 0) {
        <div class="flex flex-wrap gap-2 mt-2">
          @for (teilaufgabe of warning.copyStats.copiedTeilaufgaben; track teilaufgabe.teilaufgabenId) {
          <p-tag
            [value]="'Aufgabe ' + teilaufgabe.aufgabenIndex + '.' + teilaufgabe.teilaufgabenIndex"
            severity="contrast"
            [pTooltip]="teilaufgabe.teilaufgabenTitle"
            tooltipPosition="top"
          ></p-tag>
          }
        </div>
        }
      </div>
      }

      @if ((warning.llmDetectionDetails ?? []).length > 0) {
      <div class="mt-3">
        <strong>Betroffene Antworten:</strong>
        @for (detail of warning.llmDetectionDetails; track detail.teilaufgabenId + detail.answer) {
        <div class="mt-2 border rounded p-2">
          <div class="flex align-items-center gap-2 mb-2">
            <p-tag
              [value]="'Wahrscheinlichkeit: ' + (detail.llmProbability * 100 | number:'1.0-0') + '%'"
              [severity]="getWarningSeverity(warning.type)"
            ></p-tag>
            @if (detail.aufgabenIndex && detail.teilaufgabenIndex) {
            <a
              [routerLink]="['/fallaufgaben', selectedWarning.fallaufgabenId]"
              class="text-primary font-semibold"
              target="_blank"
              rel="noopener"
            >
              Aufgabe {{ detail.aufgabenIndex }}, Teilaufgabe {{ detail.teilaufgabenIndex }}
            </a>
            }
            @if (!(detail.aufgabenIndex && detail.teilaufgabenIndex)) {
            <span class="text-sm text-slate-600">
              Teilaufgabe: {{ detail.teilaufgabenIndex ?? 'N/A' }}
            </span>
            }
          </div>
          <div class="text-sm font-semibold mb-1">Antwort vom Nutzer:</div>
          <div
            class="surface-100 border-round p-2 text-sm"
            style="white-space: pre-wrap; word-break: break-word;"
          >{{ detail.answer }}</div>
          <div class="text-sm font-semibold mb-1 mt-2">Warum wahrscheinlich KI-Antwort:</div>
          <div
            class="surface-100 border-round p-2 text-sm"
            style="white-space: pre-wrap; word-break: break-word;"
          >{{ detail.reasoning }}</div>
        </div>
        }
      </div>
      }

      @if ((warning.matchedTexts ?? []).length > 0) {
      <div class="mt-3">
        <strong>Erkannte ähnliche Texte:</strong>
        @for (match of warning.matchedTexts; track $index) {
        <div class="mt-2 border rounded p-2">
          <div class="flex align-items-center gap-2 mb-2">
            <p-tag
              [value]="'Ähnlichkeit: ' + (match.similarity * 100 | number:'1.0-0') + '%'"
              [severity]="getWarningSeverity(warning.type)"
            ></p-tag>
          </div>
          <div class="grid">
            <div class="col-6">
              <div class="text-sm font-semibold mb-1">Eigene Antwort:</div>
              <div
                class="surface-100 border-round p-2 text-sm"
                style="white-space: pre-wrap; word-break: break-word;"
              >{{ match.ownAnswer }}</div>
            </div>
            <div class="col-6">
              <div class="text-sm font-semibold mb-1">Andere Antwort:</div>
              <div
                class="surface-100 border-round p-2 text-sm"
                style="white-space: pre-wrap; word-break: break-word;"
              >{{ match.otherAnswer }}</div>
            </div>
          </div>
        </div>
        }
      </div>
      }

      @if ((warning.relatedStatuses ?? []).length > 0) {
      <div class="mt-3">
        <strong>Verbundene Nutzer:</strong>
        <div class="mt-2">
          @for (relatedStatus of warning.relatedStatuses; track relatedStatus.statusId) {
          <p-tag
            [value]="relatedStatus.userId"
            [style]="{ 'word-break': 'break-all' }"
          ></p-tag>
          }
        </div>
      </div>
      }
    </div>
    }
  </div>

  <div class="flex gap-2">
    <p-button
      label="Zur Fallaufgabe"
      icon="pi pi-pencil"
      [routerLink]="['/fallaufgaben', selectedWarning.fallaufgabenId]"
    ></p-button>
    @if (!selectedWarning.acknowledged) {
    <p-button
      label="Bestätigen"
      icon="pi pi-check"
      severity="success"
      (onClick)="acknowledge(selectedWarning); showDetailsDialog = false"
    ></p-button>
    }
    @if (selectedWarning.acknowledged) {
    <p-button
      label="Bestätigung aufheben"
      icon="pi pi-undo"
      severity="warn"
      (onClick)="unacknowledge(selectedWarning)"
    ></p-button>
    }
    <p-button
      label="Schließen"
      severity="secondary"
      (onClick)="showDetailsDialog = false"
    ></p-button>
  </div>
  }
</p-dialog>